import { z } from "zod";
const schemaWalletUserIdParams = z.object({});
const schemaWalletUserIdResults = z.object({
    userId: z.string(),
});
export const schemaWalletUserId = {
    params: schemaWalletUserIdParams,
    result: schemaWalletUserIdResults,
};
//# sourceMappingURL=WalletUserId.js.map